import { loadConnectAndInitialize } from "@stripe/connect-js";
import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
} from "@stripe/react-connect-js";
import { useState } from "react";
import { useTRPCClient } from "@/trpc";

export default function StripeOnboarding({
  onComplete,
}: {
  onComplete: () => void;
}) {
  const trpcClient = useTRPCClient();
  const [stripeConnectInstance] = useState(() => {
    const fetchClientSecret = async () => {
      // Fetch the AccountSession client secret
      const { clientSecret } =
        await trpcClient.billing.createAccountSession.mutate();
      return clientSecret;
    };
    return loadConnectAndInitialize({
      // This is your test publishable API key.
      publishableKey: import.meta.env.VITE_PUBLIC_STRIPE_PUBLISHABLE_KEY,
      fetchClientSecret: fetchClientSecret,
      appearance: {
        overlays: "dialog",
        variables: {
          colorPrimary: "#625afa",
        },
      },
    });
  });

  return (
    <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
      <div className="w-full">
        <ConnectAccountOnboarding onExit={onComplete} />
      </div>
    </ConnectComponentsProvider>
  );
}
